import { connect } from 'react-redux'
import NumberCalls from './NumberCalls'
import { get, flow } from 'lodash'
import { replace } from 'react-router-redux'
import { reduxForm } from 'redux-form'

const formName = 'numberCalls'

const stateToProps = ({ form }, { params: { serviceId }, location: { query } }) => {
  const formData = get(form, [formName, 'values'], {})
  const page = parseInt(query.page, 10) || 1
  return {
    serviceId,
    page,
    formData,
  }
}

const dispatchToProps = {
  replace,
}

export default flow(
  connect(stateToProps, dispatchToProps),
  reduxForm({ form: formName })
)(NumberCalls)



// WEBPACK FOOTER //
// ./src/pages/NumberCalls/NumberCalls.container.js